import equal from 'fast-deep-equal';

import { FnsCheckStatusesEnum } from '../../../KnmErknmPackage/ErknmSubjectModule/enums/FnsCheckStatusesEnum';
import { IKnmCheckSubjectResult } from '../../../APIPackage/KnmModule/interfaces/IKnmCheckSubjectResult';
import { ILegalEntityLookup } from '../../../APIPackage/FnsModule/interfaces/ILegalEntityLookup';
import { fnsCheckMessageByStatuses } from '../../../KnmErknmPackage/ErknmSubjectModule/constants/fnsCheckMessageByStatuses';

export const isOrganizationNameFnsError = (subjectResult: IKnmCheckSubjectResult | null | undefined) => {
  return subjectResult && subjectResult.isOrganizationNameError;
};

export const isFnsAddressFnsError = (subjectResult: IKnmCheckSubjectResult | null | undefined) => {
  return subjectResult && subjectResult.isFnsAddressError;
};

export const isWorkAddressFnsError = (subjectResult: IKnmCheckSubjectResult | null | undefined) => {
  return subjectResult && subjectResult.isWorkAddressError;
};

export const valuesSubjectResultStatuses = (subjectResult: IKnmCheckSubjectResult | null | undefined) => {
  return subjectResult ? [subjectResult.egrip?.status, subjectResult.egrul?.status] : undefined;
};

export const renderFnsCheckMessage = (
  subjectResult: IKnmCheckSubjectResult | null | undefined,
  lookupData: ILegalEntityLookup | boolean | undefined,
  isAutocomplete: boolean | undefined,
) => {
  if (!subjectResult) {
    return;
  }

  const fnsCheckMessage = fnsCheckMessageByStatuses.find(item =>
    equal(item.statuses.sort(), valuesSubjectResultStatuses(subjectResult)?.sort()),
  );

  if (
    (typeof lookupData === 'boolean' && lookupData) ||
    lookupData ||
    fnsCheckMessage?.type === FnsCheckStatusesEnum.DATA_NOT_EQUALS_ERVK ||
    (fnsCheckMessage?.type !== FnsCheckStatusesEnum.NO_DATA_53 &&
      fnsCheckMessage?.type !== FnsCheckStatusesEnum.NO_DATA_56 &&
      isAutocomplete)
  ) {
    return;
  }

  return fnsCheckMessage?.fnsCheckMessage;
};

export const renderFnsErvkEqualsError = (
  subjectResult: IKnmCheckSubjectResult | null | undefined,
  lookupData: ILegalEntityLookup | boolean | undefined,
  isAutocomplete: boolean | undefined,
  styles: string | undefined,
) => {
  if (!subjectResult) {
    return;
  }

  const fnsCheckMessage = fnsCheckMessageByStatuses.find(item =>
    equal(item.statuses.sort(), valuesSubjectResultStatuses(subjectResult)?.sort()),
  );

  if (
    (typeof lookupData === 'boolean' && lookupData) ||
    lookupData ||
    fnsCheckMessage?.type !== FnsCheckStatusesEnum.DATA_NOT_EQUALS_ERVK ||
    isAutocomplete
  ) {
    return;
  }

  return (
    <div data-type={fnsCheckMessage?.type} className={styles}>
      {fnsCheckMessage?.fnsCheckMessage}
    </div>
  );
};
